import styled from 'styled-components';

export const StyledSvg = styled.svg(({ theme: { size } }) => ({
  width: size.units(4),
  height: size.units(4),
  minWidth: size.units(4),
  minHeight: size.units(4),
}));

export const StyledImage = styled.image(({ theme: { size } }) => ({
  width: size.units(4),
  height: size.units(4),
}));
